import {shortDocumentPattern} from './documentShortCode';
import { isErpPath } from './erpRoutes';
import metadata from './siteMetadata.json';

const publicUrl = process.env.PUBLIC_URL || '';

/** Keep document identity in sync with both direct loads and client-side navigation. */
export function applySiteIdentity(pathname: string) {
    if(shortDocumentPattern.test(pathname))return;
    const isErp = isErpPath(pathname);
    const site = isErp ? metadata.erp : metadata.logistics;
    const name = site.name;
    const icon = `${publicUrl}${site.icon}`;
    const image = site.image;
    document.title = name;
    document.querySelector('meta[name="apple-mobile-web-app-status-bar-style"]')?.setAttribute('content', 'default');
    document.querySelector('link[rel="icon"]')?.setAttribute('href', icon);
    document.querySelectorAll('meta[name="apple-mobile-web-app-title"], meta[name="application-name"]').forEach(meta => meta.setAttribute('content', name));
    const touchIcon = document.querySelector('link[rel="apple-touch-icon"]');
    touchIcon?.setAttribute('href', `${publicUrl}${site.touchIcon}`);
    if (isErp) touchIcon?.setAttribute('sizes', '1024x1024'); else touchIcon?.removeAttribute('sizes');
    document.querySelector('link[rel="manifest"]')?.setAttribute('href', `${publicUrl}${site.manifest}`);
    document.querySelectorAll('meta[property="og:title"], meta[name="twitter:title"]').forEach(meta => meta.setAttribute('content', site.title));
    document.querySelector('meta[property="og:url"]')?.setAttribute('content', site.url);
    document.querySelectorAll('meta[property="og:image"], meta[name="twitter:image"]').forEach(meta => meta.setAttribute('content', image));
    document.querySelectorAll('meta[name="description"], meta[property="og:description"], meta[name="twitter:description"]').forEach(meta => meta.setAttribute('content', site.description));
}
